import React from 'react'
import { Button, Text, Title } from 'components'
import ProposalDataSection from './ProposalDataSection'
import SalesChannelSection from './SalesChannelSection'
import PaymentMethodSection from './PaymentMethodSection'
import ProponentSection from './ProponentSection'
import styles from '../ProposalWizard.module.scss'

const FormScreen = ({
  form,
  touched,
  errors,
  onChange,
  onBlur,
  onAddAttachment,
  onRemoveAttachment,
  onTryReview,
  onGoToIntro,
  loadingSalesChannel,
}) => {
  const showProposalData = errors.isPartnerStepValid
  const showPaymentMethod =
    showProposalData &&
    errors.isProposalValueValid &&
    errors.isJustificationValid
  const showProponent = showPaymentMethod && errors.isPaymentValid

  return (
    <>
      <header className={styles.header}>
        <Title type="h1" fontSize="xlarge">
          Faça Sua Proposta
        </Title>
        <Text fontSize="medium" color="lightBlueColor">
          Os campos aparecem conforme você avança. Leva cerca de 3 minutos.
        </Text>
      </header>
      <main className={styles.main}>
        <SalesChannelSection
          form={form}
          touched={touched}
          onChange={onChange}
          onBlur={onBlur}
          loadingSalesChannel={loadingSalesChannel}
        />

        {showProposalData && (
          <>
            <hr className={styles.divider} />
            <ProposalDataSection
              form={form}
              touched={touched}
              errors={errors}
              onChange={onChange}
              onBlur={onBlur}
              onAddAttachment={onAddAttachment}
              onRemoveAttachment={onRemoveAttachment}
            />
          </>
        )}

        {showPaymentMethod && (
          <>
            <hr className={styles.divider} />
            <PaymentMethodSection
              form={form}
              touched={touched}
              errors={errors}
              onChange={onChange}
              onBlur={onBlur}
            />
          </>
        )}

        {showProponent && (
          <>
            <hr className={styles.divider} />
            <ProponentSection
              form={form}
              touched={touched}
              errors={errors}
              onChange={onChange}
              onBlur={onBlur}
            />
          </>
        )}

        <div className={styles.importantBox}>
          <Text fontSize="small" color="lightBlueColor">
            <strong>Importante:</strong> os dados informados serão utilizados
            apenas para análise desta proposta pelo Vendedor.
          </Text>
        </div>
      </main>
      <footer className={styles.footer}>
        <Button
          type="outline"
          className={styles.outlineButton}
          onClick={onGoToIntro}
          id="voltar"
        >
          Voltar
        </Button>
        <Button onClick={onTryReview} id="revisar_proposta">
          Revisar proposta
        </Button>
      </footer>
    </>
  )
}

export default React.memo(FormScreen)
